export default "<div class=\"fondo-container\">\n\t<router-outlet></router-outlet>\n</div>"